export function resolveWizardPlan(response) {

    if (!response?.plan) return null

    const plan = response.plan

    const identities = plan.identities.map(i => ({
        key: i.key,
        status: i.status,
        icon: i.status === "create" ? "➕" : "✔"
    }))

    const relations = plan.relations.map(r => ({
        parent: r.parent,
        child: r.child,
        type: r.type,
        label: `${r.parent} → ${r.child}`
    }))

    const secrets = plan.secrets.map(s => ({
        identity: s.identity,
        type: s.type,
        masked: "••••••••"
    }))

    return {
        identities,
        relations,
        secrets
    }
}